import React, { useEffect, useState } from 'react';
import { Link, useParams } from "react-router-dom";
import axios from 'axios';
import { MdDeleteForever } from "react-icons/md";
import { FaEdit } from "react-icons/fa";
import { toast } from 'react-toastify';
import Navbar from '../Navbar';
import { FaUsers } from "react-icons/fa";
import { MdAddToPhotos } from "react-icons/md";
import Menu_Items from '../Menu_Items';

function Users() {
  const { id } = useParams();
  const [users, setusers] = useState({});
  const [sortOrder, setSortOrder] = useState("asc"); // Track sorting order
  const [delete_box, setdelete_box] = useState(false);
  const [delete_id, setdelete_id] = useState(null)

  const menus = [
    {
      name: 'Integrations',
      id
    },
    {
      name: 'Users',
      id
    }
  ];
  const getusers = async () => {
    await axios.get(`/user/${id}`).then((res) => {
      setusers(res.data);
    })
      .catch((err) => {
        toast.error("Error", {
          autoClose: 2000, // 2 seconds
        });
      })
  };
  const handleSort = (name) => {
    const newOrder = sortOrder === "asc" ? "desc" : "asc"; // Toggle order
    const sorted = [...users].sort((a, b) => {
      if (typeof a[name] === "string") {
        return newOrder === "asc"
          ? a[name].localeCompare(b[name])
          : b[name].localeCompare(a[name]);
      } else {
        return newOrder === "asc" ? a[name] - b[name] : b[name] - a[name]; // Numerical sorting
      }
    })
    setusers(sorted);
    setSortOrder(newOrder);
  };
  const del = async () => {
    await axios.delete(`/user/${delete_id}`).then((res) => {
      getusers();
      setdelete_id(null)
      setdelete_box(false)
    })
      .catch((err) => {
        toast.error("Error", {
          autoClose: 2000, // 2 seconds
        });
      });
  };
  useEffect(() => {
    getusers();

  }, []);
  return (
    <div className='container df fdc ac'>
      <Navbar />
      <div className='main_box df'>
        <Menu_Items menu={menus} />
        <div className='content df fdc ac'>
          <div className='page_header df jb ac'>
            <div className='w90 df ac'>
              <FaUsers className='page_icon db' />
              <p>Users</p>
            </div>
            <Link to={`/user/add/${id}`} className='w5' ><MdAddToPhotos className='icon3 g' /></Link>
          </div>
          <table className='df fdc ac box'>
            <thead>
              <tr className='df js ac' style={{ cursor: "pointer" }}>
                <th onClick={() => { handleSort('name') }}>Name {sortOrder === "asc" ? "▲" : "▼"}</th>
                <th onClick={() => { handleSort('mail') }}>Mail Id {sortOrder === "asc" ? "▲" : "▼"}</th>
                <th onClick={() => { handleSort('role') }}>Role {sortOrder === "asc" ? "▲" : "▼"}</th>
                <th onClick={() => { handleSort('sso') }}>SSO {sortOrder === "asc" ? "▲" : "▼"}</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {
                users.length > 0 && users.map((user, index) => {
                  return (
                    <tr className='df js ac' key={index}>
                      <td className='df jc ac'>{user.name}</td>
                      <td className='df jc ac'>{user.mail}</td>
                      <td className='df jc ac'>{user.role}</td>
                      <td className='df jc ac'>{user.sso}</td>
                      <td className='df jc ac gap2'>
                        <Link to={`/user/edit/${id}/${user.id}`} className='tooltip' icon-name="Edit"><FaEdit className='icon2 db' /></Link>
                        <Link to={`#`} className='tooltip' icon-name="Delete"><MdDeleteForever className='icon2 r' onClick={() => { setdelete_box(true); setdelete_id(user.id) }} /></Link>
                      </td>
                    </tr>
                  )
                })
              }{
                users.length === 0 && <tr className="h65 df jc ac bnone">
                  <td className="w100 bnone tac no_Records">No Records</td>
                </tr>
              }
            </tbody>
          </table>
        </div>
      </div>
      {
        delete_box &&
        <div className='dialog_bg'>
          <div className='delete_box'>
            <h1 className='h5 w80 df ac r'>Delete</h1>
            <p className='h5 w80'>Are You Sure You Want to Delete This Item ?</p>
            <div className='h5 w40 df jb ac'>
              <button className='btn l_black' onClick={() => setdelete_box(false)}>Cancel</button>
              <button className='btn red' onClick={() => del()}>Delete</button>
            </div>
          </div>
        </div>
      }
    </div >

  )
}

export default Users;